import React from "react";
import BG3 from "./img/bg3.jpg";
import Participate from "./img/participate.png";
import Participate1 from "./img/participate-line1.png";
import Participate2 from "./img/participate-line2.png";
import HTMLReactParser from "html-react-parser";
import "./styles.scss";
import { useTranslation } from 'react-i18next';

export default function HowToPractice(props) {
  const { t } = useTranslation();
  const keyData = props.data;
  return (
    <div>
      <section
        style={{
          background: BG3,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div class="w-100 pt-50 pb-0 position-relative">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0 homepageFirstHeader">
                {t('How_to_Participate')}
                  {/* How to Participate  */}
                  </h2>
              </div>
              <div class="row">
                {/* <!-- <div class="col-md-1 col-sm-12 col-lg-1"></div> --> */}
                <div
                  class="col-md-3 col-sm-12 col-lg-3 wow slideInLeft"
                  style={{ textAlign: "center" }}
                >
                  <img
                    class="participate-line"
                    src={Participate2}
                  />
                </div>
                <div class="col-md-6 col-sm-12 col-lg-6"></div>
                <div
                  class="col-md-3 col-sm-12 col-lg-3 wow slideInRight"
                  style={{ textAlign: "center" }}
                >
                  <img
                    class="participate-line2"
                    src={Participate1}
                  />
                </div>
              </div>

              <div class="col-md-3 col-sm-12 col-lg-3">
                <div
                  class="col-md-3 col-6 col-lg-3 marginAuto"
                  style={{ marginTop: "75px" }}
                >
                  <div
                    class="button-participate wow slideInLeft"
                    style={{ pointerEvents: "none" }}
                  >
                    <h4
                      class="mb-0"
                      style={{
                        lineHeight: "22px",
                        paddingBottom: "10px",
                        fontSize: "20px",
                      }}
                    >
                      {keyData[0].Heading}
                    </h4>
                    <div className="" >
                    {HTMLReactParser(keyData[0].Text)}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-lg-6 wow fadeInDown">
                .
                <div class="pm-img">
                  {/* <!-- <img src="assets/images/project-overview.png"> --> */}
                  <img class="img-fluid" src={Participate} alt="" />
                </div>
              </div>
              <div class="col-md-3 col-sm-12 col-lg-3">
                <div
                  class="col-md-3 col-6 col-lg-3 marginAuto"
                  style={{ marginTop: "75px" }}
                >
                  <div
                    class="button-participate wow slideInRight"
                    style={{ pointerEvents: "none" }}
                  >
                    <h4
                      class="mb-0"
                      style={{
                        lineHeight: "22px",
                        paddingBottom: "10px",
                        fontSize: "20px",
                      }}
                    >
                      {keyData[1].Heading}
                    </h4>
                    {HTMLReactParser(keyData[1].Text)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
